import React, { useContext, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import AuthContext from '../util/AuthContext';
import SearchBarSmall from './SearchBarSmall';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';

export default function Header({ resetHomePage, hideSearch }) {
  const { user, logout, login } = useContext(AuthContext);
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const isActive = (path) => location.pathname.startsWith(path);

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-2 sm:px-6 py-3 flex items-center justify-between min-h-[56px]">
        {/* Left Section: Logo + Navigation */}
        <div className="flex items-center space-x-2">
          <Link to="/" onClick={resetHomePage}>
            <img src="/assets/potluck-logo.png" alt="Potluck logo" className="w-9 h-9 rounded-full" />
          </Link>
          <Link to="/" onClick={resetHomePage} className="text-xl font-bold text-green-600">Potluck</Link>

          <nav className="hidden lg:flex items-center space-x-6 pl-4">
            <Link to="/discover" className={`text-md ${isActive('/discover') ? 'font-semibold text-green-600' : 'text-gray-700 hover:text-green-600'}`}>Discover</Link>
            {user && (
              <Link to="/my-recipes" className={`text-md ${isActive('/my-recipes') ? 'font-semibold text-green-600' : 'text-gray-700 hover:text-green-600'}`}>My Recipes</Link>
            )}
          </nav>
        </div>

        {/* Right Section: Search Bar + Login/Logout */}
        <div className="flex items-center space-x-2 sm:space-x-6">
          {/* Keeps space for search bar for consistent height */}
          <div className={`hidden lg:flex ${hideSearch ? 'invisible' : 'visible'}`}>
            <SearchBarSmall />
          </div>

          {user ? (
            <span onClick={logout} className="hidden lg:flex cursor-pointer text-md text-gray-700 hover:text-green-600">Logout</span>
          ) : (
            <span onClick={login} className="hidden lg:flex cursor-pointer text-md text-gray-700 hover:text-green-600">Login</span>
          )}
        </div>

        {/* Mobile Menu Toggle */}
        <button className="lg:hidden" onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? <XMarkIcon className="w-6 h-6" /> : <Bars3Icon className="w-6 h-6" />}
        </button>
      </div>

      {/* Mobile Menu Dropdown */}
      {menuOpen && (
        <div className="lg:hidden bg-white shadow-lg absolute top-full left-0 right-0 px-2 sm:px-6 py-4 space-y-4">
          {!hideSearch && <SearchBarSmall />}
          <Link to="/discover" className={`block text-md ${isActive('/discover') ? 'font-semibold text-green-600' : 'text-gray-700 hover:text-green-600'}`} onClick={() => setMenuOpen(false)}>Discover</Link>
          {user && <Link to="/my-recipes" className={`block text-md ${isActive('/my-recipes') ? 'font-semibold text-green-600' : 'text-gray-700 hover:text-green-600'}`} onClick={() => setMenuOpen(false)}>My Recipes</Link>}
          {user ? (
            <span onClick={() => { logout(); setMenuOpen(false); }} className="block cursor-pointer text-md text-gray-700 hover:text-green-600">Logout</span>
          ) : (
            <span onClick={() => { login(); setMenuOpen(false); }} className="block cursor-pointer text-md text-gray-700 hover:text-green-600">Login</span>
          )}
        </div>
      )}
    </header>
  );
}
